import React, { FunctionComponent } from "react";
import { IIconProps } from "./icon";

export const ShopIcon: FunctionComponent<IIconProps> = (props) => {
  const { color, outlined, ...rest } = props;
  return (
    <svg width="20px" height="22px" viewBox="0 0 20 22" {...rest}>
      <g
        id="Symbols"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g id="Overrides/Icons/Shop" transform="translate(-2.000000, -1.000000)" stroke={color} strokeWidth="2">
          <g id="Group" transform="translate(3.000000, 2.000000)">
            <path
              d="M5.18808421,8.4057971 L5.18808421,3.72670807 C5.18808421,1.66850404 6.89582938,0 9.00243981,0 C11.1090502,0 12.8167954,1.66850404 12.8167954,3.72670807 L12.8167954,8.4057971"
              id="Path"
            ></path>
            <path
              d="M17.9735171,17.515528 L17.210646,6.7494824 C17.1785441,6.28355626 16.782488,5.92157743 16.3045247,5.92132505 L1.69781206,5.92132505 C1.21984872,5.92157743 0.823792646,6.28355626 0.791690696,6.7494824 L0.0288195756,17.515528 C0.00960652521,17.7915804 0,18.0676329 0,18.3436853 C0,19.2584426 0.758997854,20 1.69526916,20 L16.3045247,20 C17.240796,20 17.9997938,19.2584426 17.9997938,18.3436853 C18.0014891,18.0676329 17.9927302,17.7915804 17.9735171,17.515528 Z"
              id="Path"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};
